import { render, staticRenderFns } from "./AllCategories.vue?vue&type=template&id=34ef341d&scoped=true"
import script from "./AllCategories.vue?vue&type=script&lang=js"
export * from "./AllCategories.vue?vue&type=script&lang=js"
import style0 from "./AllCategories.vue?vue&type=style&index=0&id=34ef341d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef341d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ef341d')) {
      api.createRecord('34ef341d', component.options)
    } else {
      api.reload('34ef341d', component.options)
    }
    module.hot.accept("./AllCategories.vue?vue&type=template&id=34ef341d&scoped=true", function () {
      api.rerender('34ef341d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AllCategories.vue"
export default component.exports